import { createFileRoute, redirect } from '@tanstack/react-router'

/** The segment holds no page of its own; the coarsest list stands in. */
export const Route = createFileRoute(
  '/internal/system/administration/classifications/',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/internal/system/administration/classifications/categories',
    })
  },
})
